import { defineComponent as _defineComponent } from 'vue'
import ReasonCard from '@/components/yagiprime/ReasonCard.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoReasonCard',
  props: {
    currentCardId: null,
    formatId: null,
    exampleSentences: null,
    textareaMinRows: null,
    previewErrors: null
  },
  setup(__props: any) {



const formatData = useRirekishoFormatData()

return { __sfc: true,formatData, ReasonCard }
}

})